<template>
  <div class="spin">
    <a-spin size="large"></a-spin>
  </div>
</template>

<script>
export default {
  name: 'spin'
}
</script>

<style lang="less" scoped>
.spin {
  position: fixed;
  top: 64px;
  left: 0;
  width: 100vw;
  height: calc(100vh - 64px);

  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
</style>